import { render, staticRenderFns } from "./ListPatients.vue?vue&type=template&id=50e882a6&scoped=true&"
import script from "./ListPatients.vue?vue&type=script&lang=ts&"
export * from "./ListPatients.vue?vue&type=script&lang=ts&"
import style0 from "./ListPatients.vue?vue&type=style&index=0&id=50e882a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e882a6",
  null
  
)

export default component.exports